import baseUrl, { baseUrl2 } from "./baseUrl";
const apiEndPoint = (data) => {
  return {
    // 👇👇Login Endpoint👇👇
    LOGINWITHGOOGLE: `${baseUrl}/google`,
    LOGINWITHGOOGLESUCCESS: `${baseUrl}/login/success`,
    USER_EXIST: `${baseUrl}/user-exist`,
    CREATE_ACCOUNT: `${baseUrl}/create-account`,
    LOGOUT: `${baseUrl}/logout`,
    SIGNIN: `${baseUrl}/signin`,
    SIGNUP: `${baseUrl}/signup`,
    SEND_OTP: `${baseUrl}/send-otp`,
    SEND_RESET_LINK: `${baseUrl}/send-reset-link-pratham`,
    RESET_PASSWORD: `${baseUrl}/reset-password`,
    VIRIFY_OTP: `${baseUrl}/verify-otp`,
    CHANGE_PROJECT: `${baseUrl}/change-project`,
    CHANGE_PASSWORD: `${baseUrl}/change-password`,
    FOUR_VIDEO: `${baseUrl}/get-four-pipeline`,
    // 👇👇Dashboard Endpoint👇👇
    GETSTRUCTURE: `${baseUrl}/get-dashboard-structure`,
    MOSTFREQUENTALERTS: `${baseUrl}/most-frequent-alerts${data?.query}`,
    // 👇👇Project Management Endpoint👇👇
    POJECT_MANAGEMENT: `${baseUrl}/project-management`,
    CREATE_PROJECT: `${baseUrl}/create-project`,
    CREATE_PROJECT2: `${baseUrl}/create-project2`,
    Get_code: `${baseUrl}/get-code`,
    For_user_create: `${baseUrl}/for-user-create`,
    UPDATE_PROJECT: `${baseUrl}/update-project`,
    DELETE_PROJECT: `${baseUrl}/delete-project`,
    GET_USER_ASSERT: `${baseUrl}/get-user-assert`,
    GET_ALL_PROJECT: `${baseUrl}/get-all-project`,
    // 👇👇User Management Endpoint👇👇
    GET_ALL_USER: `${baseUrl}/get-all-user`,
    GET_ONE_USER: `${baseUrl}/get-one-user`,
    GET_ONE_USER2: `${baseUrl}/get-one-user2`,
    CREATE_NEW_USER: `${baseUrl}/create-new-user`,
    CREATE_NEW_USER2: `${baseUrl}/create-new-user2`,
    UPDATE_USER: `${baseUrl}/update-user`,
    DELETE_USER: `${baseUrl}/delete-user`,
    USER_TREE: `${baseUrl}/user-tree`,
    ALL_USER: `${baseUrl}/all-user`,
    CHANGE_PROFILE: `${baseUrl}/change-profile`,
    // 👇👇Role Management Endpoint👇👇
    GET_ROLE_LIST: `${baseUrl}/get-role-list`,
    CREATE_ROLE: `${baseUrl}/create-role`,
    UPDATE_ROLE: `${baseUrl}/update-role`,
    DELETE_ROLE: `${baseUrl}/delete-role`,
    // 👇👇Module Endpoint👇👇
    GET_Module_LIST: `${baseUrl}/module-list`,
    // 👇👇Warehouse Endpoint👇👇
    GET_WAREHOUSE_LIST: `${baseUrl}/warehouse-list`,
    CREATE_WAREHOUSE: `${baseUrl}/create-warehouse`,
    CREATE_WAREHOUSE2: `${baseUrl}/create-warehouse2`,
    UPDATE_WAREHOUSE: `${baseUrl}/update-warehouse`,
    DELETE_WAREHOUSE: `${baseUrl}/delete-warehouse`,
    WAREHOUSE_LIST_PROJECTID: `${baseUrl}/warehouse-list-with-project`,
    // 👇👇Cluster Endpoint👇👇
    GET_CLUSTER_LIST: `${baseUrl}/cluster-list`,
    CREATE_CLUSTER: `${baseUrl}/create-cluster`,
    UPDATE_CLUSTER: `${baseUrl}/update-cluster`,
    DELETE_CLUSTER: `${baseUrl}/delete-cluster`,
    // 👇👇Devices Endpoint👇👇
    GET_DEVICE_LIST: `${baseUrl}/device-list`,
    GET_DEVICE_LIST_FILTER: `${baseUrl}/device-list-filter`,
    GET_LOCATION: `${baseUrl}/get-location`,
    CREATE_DEVICE: `${baseUrl}/create-device`,
    CREATE_DEVICE2: `${baseUrl}/create-device2`,
    UPDATE_DEVICE: `${baseUrl}/update-device`,
    DELETE_DEVICE: `${baseUrl}/delete-device`,
    GET_GPU: `${baseUrl}/get-gpu`,
    // 👇👇Alerts Endpoint👇👇
    GET_ALERT_LIST: `${baseUrl}/alerts-list`,
    GET_ALERT_LIST_ALL: `${baseUrl}/alerts-list-all`,
    CREATE_ALERT: `${baseUrl}/create-alert`,
    UPDATE_ALERT: `${baseUrl}/update-alert`,
    DELETE_ALERT: `${baseUrl}/delete-alert`,
    // 👇👇Alerts Endpoint👇👇
    GET_ALERT_TYPE_LIST: `${baseUrl}/alerts-type-list`,
    // 👇👇Alerts Pipeline Endpoint👇👇
    GET_ALERT_PIPELINE_LIST: `${baseUrl}/alerts-pipeline-list`,
    CREATE_ALERT_PIPELINE: `${baseUrl}/create-alert-pipeline`,
    CREATE_PIPELINE: `${baseUrl}/create-pipeline2`,
    UPDATE_ALERT_PIPELINE: `${baseUrl}/update-alert-pipeline`,
    ALERTS_MODULE_LIST: `${baseUrl}/alerts-model-list`,
    DELETE_PIPELINE: `${baseUrl}/delete-pipeline`,
    DELETE_ALERT_PIPELINE: `${baseUrl}/delete-alert-pipeline`,
    CREATE_YML_DATA: `${baseUrl}/create-yml-data`,
    ALERT_PIPELINE: `${baseUrl}/alerts-pipeline-list-new`,
    PIPELINE_STATUS_CHANGE: `${baseUrl}/change-pipeline-status`,
    REVIEW_PIPELINE: `${baseUrl}/review-pipeline`,
    CHECK_NAME: `${baseUrl}/check-name-exist`,
    // 👇👇Events Endpoint👇👇
    GET_EVENTS_LIST: `${baseUrl}/event-list`,
    GET_COMMENT: `${baseUrl}/comment-list`,
    ADD_COMMENT: `${baseUrl}/add-comment`,
    EVENTACKNOWLWDEGE: `${baseUrl}/event-acknowledge`,
    EVENTREPORTED: `${baseUrl}/event-reported`,
    EVENTBYPIPELINEID: `${baseUrl}/event-by-pipelineId`,
    // 👇👇Overview Endpoint👇👇
    GET_OVERVIEW_STRUCTURE: `${baseUrl}/overview-structure`,
    GET_CARD_LIST: `${baseUrl}/card-data`,
    GET_EVENT_GRAPH: `${baseUrl}/event-graph-data`,
    // 👇👇Support Endpoint👇👇
    GET_SUPPORT_LIST: `${baseUrl}/get-support-list`,
    CREATE_ISSUE: `${baseUrl}/create-issue`,
    // 👇👇Notifiction👇👇
    get_notification: `${baseUrl}/get-notification`,
    create_notification: `${baseUrl}/create-notification`,
    update_notification: `${baseUrl}/update-notification`,
    delete_notification: `${baseUrl}/delete-notification`,
    // 👇👇Live Feed👇👇
    GET_LIVE_FEED: `${baseUrl}/get-live-feed`,
    PLAY_VIDEO: `${baseUrl2}/play-video`,
    GET_PLAY_BACK: `${baseUrl}/get-playback`,

    // 👇👇 MEDIA👇👇
    CRAETE_MEDIA: `${baseUrl}/create-media`,
    GET_MEDIA: `${baseUrl}/get-media`,
    // 👇👇 CONTACT 👇👇
    CONTACT_US: `${baseUrl}/contact-us`,
    // 👇👇 REPORTS 👇👇
    GET_GRAPH_DATA: `${baseUrl}/get-graph-data`,
    GET_GRAPH_DATA_LIVE: `${baseUrl}/get-graph-live`,
    // 👇👇Other👇👇
    upload_img_aws: `${baseUrl}/upload-img-aws`,
    upload_video: `${baseUrl2}/upload-video`,
    // CERDIT 
    GET_CREDIT:`${baseUrl}/get-credit-score`,

     // ----------------------------START-PRATHAM------------------------------
     DEVICE_WITH_ID: `${baseUrl}/device-with-id`,
     GET_YML_FOR_UI: `${baseUrl}/get-ylm-for-ui`,
     UPDATE_YML_FILE: `${baseUrl}/update-ylm-file`,
     GET_USECASE:`${baseUrl}/get-usecase-list`,
  };
};

export default apiEndPoint;
